import { Dispatch, SetStateAction } from "react";
import { AppDispatch } from "@portal/redux/store";
import { setSavingsAgreementAdvisorCarriedOut } from "@portal/redux/reducers/ui/createSavingsAgreement";
import { OnPeriodDayChange, OnSavingsNameChange } from "../../components/handlers";

export const OnPeriodDayNumberClick = (
  index: number,
  setSelectedPeriodDayNumber: Dispatch<SetStateAction<number>>,
  dispatch: AppDispatch,
) => {
  setSelectedPeriodDayNumber(index);
  OnPeriodDayChange(index, dispatch);
};

export const OnAdvisorClick = (index: number, setAdvisorCarriedOut: Dispatch<SetStateAction<boolean>>, dispatch: AppDispatch) => {
  const advisorCarriedOut = index === 1;
  setAdvisorCarriedOut(advisorCarriedOut);
  dispatch(setSavingsAgreementAdvisorCarriedOut(advisorCarriedOut));
};

export const OnAgreementNameChange = (
  name: string,
  setAgreementName: Dispatch<SetStateAction<string>>,
  dispatch: AppDispatch,
) => {
  setAgreementName(name);
  OnSavingsNameChange(name, dispatch);
};
